export default {
  privacyPolicy: {
    en: 'Privacy Policy',
  },
  terms: {
    en: 'Terms & Conditions',
  },
}
